import { whyConfluenceSectioni18n } from "./messages/why-confluence-section.messages";
import { css } from "@compiled/react";

import { useIntl } from "react-intl";
import { media } from "@atlaskit/primitives/responsive";

import UFOSegment from "@atlaskit/react-ufo/segment";
import { InfoBox } from "@/components/adg4/info-box/src/info-box";

import { wacToken } from "@/libraries/design/foundations";

const whyConfluenceSectionStyles = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBlockStart: "80px",
    paddingBlockEnd: "64px",
    paddingInlineStart: "24px",
    paddingInlineEnd: "24px"
});

const whyBackgroundStyles = css({
    position: "absolute",
    clipPath: "polygon(0 2%, 100% 6%, 100% 92%, 0 97%)",
    backgroundColor: wacToken("color.neutral.light100"),
    maxWidth: 1440,
    width: "100%",
    minHeight: 450,
    height: "100%",
    insetBlockStart: 0,

    [media.only.sm]: {
        clipPath: "polygon(0 2%, 100% 6%, 100% 100%, 0 100%)"
    },
    [media.below.sm]: {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        height: "100%"
    }
});

const relative = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

const whyConfluenceSectionHeaderStyles = css({
    marginBlockStart: "0px",
    marginBlockEnd: "56px",

    [media.below.md]: {
        textAlign: "center"
    }
});

const infoCardContainerStyles = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "32px",
    margin: "0 auto",
    width: "100%"
});

const infoBoxGroup = css({
    display: "flex",
    flex: "1 1 auto",
    gap: "32px",
    justifyContent: "center",
    flexWrap: "wrap"
});

const WhyConfluenceSection = () => {
    const intl = useIntl();

    const infoBoxes1 = [
        {
            infoBoxId: "versatileContentCreation",
            title: intl.formatMessage(
                whyConfluenceSectioni18n.versatileContentCreationInfoBoxTitle
            ),
            paragraph: intl.formatMessage(
                whyConfluenceSectioni18n.versatileContentCreationInfoBoxParagraph
            )
        },
        {
            infoBoxId: "organizationThatScales",
            title: intl.formatMessage(
                whyConfluenceSectioni18n.organizationThatScalesInfoBoxTitle
            ),
            paragraph: intl.formatMessage(
                whyConfluenceSectioni18n.organizationThatScalesInfoBoxParagraph
            )
        }
    ];
    const infoBoxes2 = [
        {
            infoBoxId: "powerfulIntegrations",
            title: intl.formatMessage(
                whyConfluenceSectioni18n.powerfulIntegrationsInfoBoxTitle
            ),
            paragraph: intl.formatMessage(
                whyConfluenceSectioni18n.powerfulIntegrationsInfoBoxParagraph
            )
        },
        {
            infoBoxId: "dataProtection",
            title: intl.formatMessage(
                whyConfluenceSectioni18n.dataProtectionInfoBoxTitle
            ),
            paragraph: intl.formatMessage(
                whyConfluenceSectioni18n.dataProtectionInfoBoxParagraph
            )
        }
    ];

    return (
        <UFOSegment name="confluence-pt-cfind-1234-whyConfluenceSection">
            <section css={whyConfluenceSectionStyles}>
                <div css={whyBackgroundStyles} />
                <div css={relative}>
                    <h2 css={whyConfluenceSectionHeaderStyles}>
                        {intl.formatMessage(
                            whyConfluenceSectioni18n.whyConfluenceSectionHeader
                        )}
                    </h2>
                    <div css={infoCardContainerStyles}>
                        <div css={infoBoxGroup}>
                            {infoBoxes1.map((infoCardProps) => (
                                <InfoBox
                                    key={infoCardProps.infoBoxId}
                                    {...infoCardProps}
                                />
                            ))}
                        </div>
                        <div css={infoBoxGroup}>
                            {infoBoxes2.map((infoCardProps) => (
                                <InfoBox
                                    key={infoCardProps.infoBoxId}
                                    {...infoCardProps}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </UFOSegment>
    );
};

WhyConfluenceSection.displayName = "WhyConfluenceSection";

export default WhyConfluenceSection;
